import React from 'react';
export function USAFlag({
  className = ''
}: {
  className?: string;
}) {
  return <svg aria-hidden="true" focusable="false" viewBox="0 0 190 100" className={className} data-id="element-657" data-mp="1hxgrkaotonjo">
      <rect width="190" height="100" fill="#fff" data-id="element-658" data-mp="1lzbu1iihp6z1" />
      {Array.from({
      length: 7
    }, (_, i) => <rect key={i} y={i * 200 / 13} width="190" height={100 / 13} fill="#B22234" data-id="element-659" data-mp="1qq0kcuifnxwl" />)}
      <rect width="76" height={700 / 13} fill="#3C3B6E" data-id="element-660" data-mp="1vp3psg2bs653" />
      {Array.from({
      length: 9
    }, (_, row) => {
      const count = row % 2 === 0 ? 6 : 5;
      return Array.from({
        length: count
      }, (_, col) => <path key={`${row}-${col}`} d="M0-2.7 .635-.875 2.568-.834 1.027.334 1.588 2.184 0 1.08 -1.588 2.184 -1.027.334 -2.568-.834 -.635-.875Z" transform={`translate(${(row % 2 === 0 ? 6.333 : 12.666) + col * 12.666},${5.385 + row * 5.385})`} fill="#fff" data-id="element-661" data-mp="25nkkno4dx4wf" />);
    })}
    </svg>;
}